import { PortalShadow } from "@redotech/redo-customer-portal-common/portal-customization";

const SHADOW_VALUES: Record<PortalShadow, string | undefined> = {
  [PortalShadow.NONE]: undefined,
  [PortalShadow.SMALL]: "0px 2px 12px rgba(0, 0, 0, 0.10)",
  [PortalShadow.MEDIUM]: "0px 6px 25px rgba(0, 0, 0, 0.15)",
  [PortalShadow.LARGE]: "0px 16px 48px rgba(0, 0, 0, 0.28)",
};

/**
 * Resolve a shadow preset to a `box-shadow` CSS value. Returns `undefined` for
 * NONE / null / unknown so callers can skip emitting a rule entirely.
 */
export function resolveShadowValue(
  shadow: PortalShadow | null | undefined,
): string | undefined {
  if (shadow == null || shadow === PortalShadow.NONE) {
    return undefined;
  }
  return SHADOW_VALUES[shadow];
}
